import './styles.scss';
import createElement from '../../utils/createElement';

import Wrap from '../ScreenWrap';
import russiaBg from '../../../img/bg.jpg';
import THREELib from 'three-js';// '../../lib/three.min';
const THREE = THREELib();
import '../../lib/OrbitControls';
import loadImg from '../../utils/loader';
import { isEdge } from '../../utils/checkBrowser';

const keys = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };

class Screen1 {
    constructor(loader, updateParams) {
        this.html = {};
        this.wrap = null;
        this.loader = loader;
        this.updateParams = updateParams;

        this.isFocused = false;
        this.isEntered = false;
        this.isLoaded = false;

        this.cameraFirstPosition = null;
        this.content1hidden = false;
        this.content2shown = false;
        this.keys = {
            [keys.LEFT]: false,
            [keys.UP]: false,
            [keys.RIGHT]: false,
            [keys.BOTTOM]: false
        };

        this.onResize = this.onResize.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setState = this.setState.bind(this);

        this.imageUrl = russiaBg;
        this.xhr = null;
        this.timeout = null;
        this.circle = 2;
        this.circleMade = false;
        this.lastLoadedPercent = 0;
    }

    render(mountNode) {
        this.html.mountNode = mountNode;

        this.html.mainTitle = <h2 class="russia-content__main-title">Россия</h2>;

        this.html.countryName = <h3 class="russia-content__country-name">Россия</h3>;

        this.html.shadowFilter = <div class="russia-content__shadow-filter"/>;

        this.content1 = <div class="russia-content_1 invisible">
            <div class="russia-content__subtitle-1">панорама</div>
            <div class="russia-content__title-1">360</div>
            <div class="russia-content__text-1">
                Зажимай левую кнопку<br/>мыши и вращай картинку,<br/>чтобы посмотреть<br/>панорамное изображение
            </div>
        </div>;

        this.content2 = <div class="russia-content_2">
            <div class="russia-content__title-2">Безграничный<br/>экран</div>
            <div class="russia-content__text-2">Эффект полного<br/>погружения в контент<br/> и поддержка панорамной<br/>камеры Gear 360</div>
        </div>;

        this.wrap = new Wrap(<div class="russia-screen">
            { this.html.canvas =  <div id="russia" class="russia-content__canvas"/> }
            { this.html.shadowFilter }
            { this.html.mainTitle }
            { this.html.countryName }
            { this.content1 }
            { this.content2 }
        </div>);
        this.wrap.mountTo(this.html.mountNode);
    }

    size(height, width) {
        this.wrap.size(height, width);
    }

    float(floatVal){
        this.wrap.float(floatVal);
    }

    setState(state) {
        switch (state) {
            case '1': {
                try {
                    this.html.canvas.firstChild.style.opacity = 1;
                } catch (e) {}
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.content1hidden = false;
                this.content1.classList.remove('invisible');
                this.content2shown = false;
                this.content2.classList.remove('visible');
                return;
            }
            case '2': {
                if (this.isEntered && this.isFocused) {
                    ga('s8.send', 'event', 'Russia', 'final_text');
                }
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.content1hidden = true;
                this.content1.classList.add('invisible');
                this.content2shown = true;
                this.content2.classList.add('visible');
                return;
            }
            case 'initial': {
                this.content1hidden = true;
                this.content1.classList.add('invisible');
                this.content2shown = false;
                this.content2.classList.remove('visible');
                this.html.mainTitle.style.opacity = 1;
                this.html.countryName.style.opacity = 0;
                return;
            }
            case 'nothing': {
                this.content1hidden = true;
                this.content1.classList.add('invisible');
                this.content2shown = false;
                this.content2.classList.remove('visible');
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                return;
            }
            case 'afterall': {
                this.content1hidden = true;
                this.content1.classList.add('invisible');
                this.content2shown = true;
                this.content2.classList.remove('visible');
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                return;
            }

            case 'exit': {
                this.html.mainTitle.style.opacity = 1;
                this.html.countryName.style.opacity = 0;
                this.content1.classList.add('invisible');
                this.content2.classList.remove('visible');
                this.html.canvas.style.opacity = 0;
                try {
                    this.html.canvas.firstChild.style.opacity = 0;
                } catch (e) {}
                return;
            }
        }
    }

    focus() {
        this.isFocused = true;
        this.paramsUpdated();
        if (this.isEntered) {
            this.setState('1');
            this.init();
        } else {
            this.setState('initial');
        }
    }

    paramsUpdated() {
        if (this.isFocused) {
            this.updateParams(this.isFocused, this.isEntered, this.isLoaded);
        }
    }

    unFocus() {
        this.isFocused = false;

        if (!this.isLoaded) {
            if (this.xhr !== null) {
                this.xhr.abort();
            }
            this.isEntered = false;
            this.loader.loadFinished();
        }

        if (!this.isEntered){
            this.setState('initial');
        }else{
            this.setState('1');
        }

        this.paramsUpdated();
        this.removeListeners();
    }

    clickEnter() {
        this.isEntered = true;
        this.html.canvas.style.opacity = 1;
        this.paramsUpdated();
        this.load();
    }

    preload() {
        loadImg(russiaBg, p => {
            // console.log('russia ', p);
            this.lastLoadedPercent = p;
            if (this.isFocused && this.isEntered) {
                this.loader.progress(p)
            }
        }, 12300870
        ).then(img => {
            this.imageUrl = img;
            if (this.isFocused && this.isEntered) {
                this.init();
            }
        });
    }

    load() {
        this.setState('nothing');

        if (!this.isLoaded) {
            this.loader.loadStarted(this.lastLoadedPercent);
            if (this.imageUrl) {
                this.init();
            }
            //loadImg(russiaBg, this.loader.progress, 12300870, xhr => this.xhr = xhr).then(img => {
            //    this.imageUrl = img;
            //    if (this.isFocused) {
            //        this.init();
            //    }
            //});
        }else{
            this.focus();
        }
    }

    clickExit() {
        this.isEntered = false;
        this.setState('exit');
        this.loader.loadFinished();
        this.removeListeners();
        this.paramsUpdated();
    }

    rotate() {
        if (!this.isLoaded || !this.isFocused || !this.isEntered) {
            return;
        }
        const _rotate = keyCode => {
            const angle = 0.3;
            const speed = 5;
            switch (keyCode) {
                //case keys.UP:
                //    this.controls.rotateUp(2 * Math.PI * -angle / document.body.clientWidth * speed);
                //    break;
                //
                //case keys.BOTTOM:
                //    this.controls.rotateUp(2 * Math.PI * angle / document.body.clientWidth * speed);
                //    break;

                case keys.LEFT:
                    this.controls.rotateLeft(2 * Math.PI * -angle / document.body.clientWidth * speed);
                    break;

                case keys.RIGHT:
                    this.controls.rotateLeft(2 * Math.PI * angle / document.body.clientWidth * speed);
                    break;
            }
            this.controls.interactionStarted = true;
            this.controls.update();
        };
        for (let key in this.keys) {
            if (this.keys[key]) {
                _rotate(parseInt(key));
            }
        }
    }

    init() {
        let camera, controls;

        this.path = 0;
        this.lastPosition = -1.4711276743037347;
        this.direction = 1;

        this.animate = () => {
            if (!this.isFocused || !this.isEntered) {
                return;
            }

            //this.rotate();

            window.requestAnimationFrame(this.animate);

            if (this.controls.interactionStarted && !this.content1hidden) {
                this.setState('nothing');
            }

            //if (this.controls.interactionStarted && !this.timeout) {
            //    const setState2 = () => {
            //        this.setState('2');
            //        this.timeout = setTimeout(() => {
            //            this.setState('afterall');
            //            this.timeout = setTimeout(setState2, 5000);
            //        }, 3000);
            //    };
            //
            //    this.timeout = setTimeout(setState2, 5000);
            //}

            if (this.lastPosition < 0 && this.controls.spherical.theta > 0) {
                this.direction = -1;
            }
            if (this.lastPosition > 0 && this.controls.spherical.theta < 0) {
                this.direction = 1;
            }

            this.path += (Math.abs(this.controls.spherical.theta) - Math.abs(this.lastPosition)) * this.direction;
            this.lastPosition = this.controls.spherical.theta;

            if (Math.abs(this.path) >= this.circle * Math.PI && !this.circleMade) {
                this.path = 0;
                this.circleMade = true;
                this.setState('2');
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                this.timeout = setTimeout(() => { this.setState('afterall') }, 5000);
            }

            this.controls.update();
            this.renderer.render(this.scene, this.camera);
        };

        this.container = document.getElementById('russia');

        camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1100);
        this.camera = camera;
        camera.position.z = .1;
        camera.position.x = -1;
        camera.position.y = 0;

        this.cameraFirstPosition = new THREE.Vector3();
        this.cameraFirstPosition.copy(camera.rotation);

        controls = new THREE.OrbitControls(camera);
        controls.enableZoom = false;
        controls.enablePan = false;
        controls.rotateSpeed = 1.0;
        controls.zoomSpeed = 1.2;
        controls.panSpeed = 1.0;
        controls.dynamicDampingFactor = 0.3;
        controls.interactionStarted = false;
        this.controls = controls;

        if (!this.isLoaded) {
            this.renderScene();
        }

        this.addListeners();
        this.animate();
    }

    renderScene() {
        let scene, renderer, geometry, mesh;

        scene = new THREE.Scene();
        this.scene = scene;

        geometry = new THREE.SphereGeometry(100, 16 * 2, 8 * 2);
        geometry.scale(-1, 1, 1);

        renderer = new THREE.WebGLRenderer({
            devicePixelRatio: window.devicePixelRatio || 1
        });
        this.renderer = renderer;
        var an = renderer.getMaxAnisotropy();

        var material = new THREE.MeshBasicMaterial({
            map: new THREE.TextureLoader().load(this.imageUrl, () => {
                if (this.isFocused) {
                    this.isLoaded = true;
                    this.loader.loadFinished();
                    this.paramsUpdated();
                    this.setState('1');
                }
            })
        });
        this.material = material;
        this.material.anisotropy = an;

        mesh = new THREE.Mesh(geometry, this.material);
        scene.add(mesh);

        renderer.setPixelRatio(window.devicePixelRatio || 1);
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.domElement.style.position = 'absolute';
        renderer.domElement.style.top = 0;
        if (!this.isLoaded){
            this.container.appendChild(renderer.domElement);
        }
    }

    addListeners() {
        window.addEventListener('resize', this.onResize, false);

        //if(!isEdge()) {
        //    window.addEventListener('keydown', this.onKeyDown, false);
        //    window.addEventListener('keyup', this.onKeyUp, false);
        //}
    }

    removeListeners() {
        //window.removeEventListener('resize', this.onResize);

        //if (!isEdge()){
        //    window.removeEventListener('keydown', this.onKeyDown);
        //    window.removeEventListener('keyup', this.onKeyUp);
        //}

        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    onKeyDown(event) {
        if (Object.values(keys).indexOf(event.keyCode) !== -1) {
            this.keys[event.keyCode] = true;
        }
    }

    onKeyUp(event) {
        if (Object.values(keys).indexOf(event.keyCode) !== -1) {
            this.keys[event.keyCode] = false;
        }
    }

    onResize(event) {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    degInRad(deg) {
        return deg * Math.PI / 180;
    }

    isEnteredNow(){
        return this.isEntered;
    }
}

export default Screen1;


// WEBPACK FOOTER //
// ./src/js/screens/Screen1/index.js